import { Chip } from '@mui/material';

const STATUS_STYLES = {
    PENDING: {
        label: 'PENDING',
        variant: 'outlined',
        sx: { bgcolor: '#fff3e0', color: '#ef6c00', borderColor: '#ffe0b2' },
    },
    VALIDATED: {
        label: 'VALIDATED',
        variant: 'filled',
        sx: { bgcolor: '#e8f5e9', color: '#2e7d32', borderColor: '#c8e6c9' },
    },
    REJECTED: {
        label: 'REJECTED',
        variant: 'filled',
        sx: { bgcolor: '#ffebee', color: '#c62828', borderColor: '#ffcdd2' },
    },
    NEW: {
        label: 'NOUVEAU',
        variant: 'filled',
        sx: { bgcolor: '#fff3e0', color: '#bf360c', borderColor: '#ffe0b2' },
    },
    REVIEWING: {
        label: 'REVUE',
        variant: 'outlined',
        sx: { bgcolor: '#e3f2fd', color: '#1565c0', borderColor: '#bbdefb' },
    },
    RESOLVED: {
        label: 'RÉSOLU',
        variant: 'filled',
        sx: { bgcolor: '#e8f5e9', color: '#1b5e20', borderColor: '#c8e6c9' },
    },
    DISMISSED: {
        label: 'CLASSÉ',
        variant: 'outlined',
        sx: { bgcolor: '#eceff1', color: '#37474f', borderColor: '#cfd8dc' },
    },
};

export default function StatusChip({ value, size = 'small' }) {
    const config =
        STATUS_STYLES[value] || {
            label: value || 'UNKNOWN',
            variant: 'outlined',
            sx: { bgcolor: '#eceff1', color: '#455a64', borderColor: '#cfd8dc' },
        };

    return (
        <Chip
            size={size}
            label={config.label}
            variant={config.variant}
            sx={{ fontWeight: 600, ...config.sx }}
        />
    );
}
